import { GridFilterModel } from "@mui/x-data-grid";
import { SortingModel } from "../../models/shared/SortingModel";
import { appendStringFilterToUri } from "../../utils/filtering";
import { api_url } from "../../utils/ApiContext";
import { BeneBrandModel } from "../../models/api/response/bene/BeneBrandModel";
import {
  FetchPaginatedApiModel,
  WithData,
  WithRecordID,
} from "../../models/shared/CommonModels";
import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "../apiCommon";

const TAKE_LIMIT = 15;

const setQueryParameters = (
  filter: GridFilterModel | undefined,
  sort: SortingModel
) => {
  let uri = api_url.concat("/api/brandbene?");

  filter?.items.forEach((item) => {
    uri = appendStringFilterToUri(item.field, "nome", item.value, uri);
    uri = appendStringFilterToUri(item.field, "descrizione", item.value, uri);
  });

  uri = uri.concat("&sort_field=", sort.field.toString());
  uri = uri.concat("&sort_direction=", sort.direction.toString());

  uri = uri.endsWith("?") ? uri.concat("skip=") : uri.concat("&skip=");

  return uri;
};

const getBeneBrands = (
  selectedId: number,
  page: number,
  sort: SortingModel,
  filter?: GridFilterModel
) => {
  let uri = setQueryParameters(filter, sort);

  let skip = 0;
  let take = TAKE_LIMIT;
  if (page > 0) skip = page * take;

  return getRequest<FetchPaginatedApiModel<BeneBrandModel[]>>(
    uri.concat(
      "&skip=",
      skip.toString(),
      "&take=",
      take.toString(),
      "&selectedId=",
      selectedId.toString()
    )
  );
};

const createBrandBene = (postdata: WithData) => {
  return postRequest(api_url.concat("/api/brandbene"), postdata.data);
};

const updateBrand = (putdata: WithRecordID) => {
  return putRequest(
    api_url.concat("/api/brandbene/", putdata.recordID.toString()),
    putdata.data
  );
};

const deleteBrand = (id: number) => {
  return deleteRequest(api_url.concat("/api/brandbene/", id.toString()));
};

const getAllBeneBrands = () => {
  return getRequest<BeneBrandModel[]>(api_url.concat("/api/brandbene"));
};

export { createBrandBene, updateBrand, deleteBrand, getBeneBrands, getAllBeneBrands };
